import { createFileRoute } from "@tanstack/react-router";
import { DashboardShell } from "@/components/DashboardShell";
import { PARTNER_NAV } from "@/lib/nav";
import { NotificationCenter } from "@/components/NotificationCenter";

export const Route = createFileRoute("/_authenticated/partner/notifications")({
  head: () => ({
    meta: [
      { title: "Notifications · Landoo Partner" },
      {
        name: "description",
        content:
          "New enquiries, listing moderation results, contact requests and subscription reminders in one place.",
      },
      { property: "og:title", content: "Notifications · Landoo Partner" },
      {
        property: "og:description",
        content:
          "New enquiries, listing moderation results, contact requests and subscription reminders in one place.",
      },
    ],
  }),
  component: () => (
    <DashboardShell title="Notifications" role="Partner" items={PARTNER_NAV}>
      <NotificationCenter />
    </DashboardShell>
  ),
});
